import { AppConsts } from '@shared/AppConsts';
import { IThemeAssetContributor } from '../ThemeAssetContributor';

export class Theme3ThemeAssetContributor implements IThemeAssetContributor {
    getAssetUrls(): string[] {
        return [AppConsts.appBaseUrl + '/assets/fonts/fonts-montserrat.min.css'];
    }
}
